var city = {
  citycode: [],
  adcode: "410000",
  name: "河南省",
  center: {
    lng: 113.753094,
    lat: 34.767052
  },
  districtList: [
    {
      citycode: "0379",
      adcode: "410300",
      name: "洛阳市",
      center: {
        lng: 112.453895,
        lat: 34.619702
      },
      districtList: [
        {
          citycode: "0379",
          adcode: "410323",
          name: "新安县",
          center: {
            lng: 112.13246,
            lat: 34.728909
          }
        },
        {
          citycode: "0379",
          adcode: "410328",
          name: "洛宁县",
          center: {
            lng: 111.652958,
            lat: 34.389371
          }
        },
        {
          citycode: "0379",
          adcode: "410327",
          name: "宜阳县",
          center: {
            lng: 112.179187,
            lat: 34.51462
          }
        },
        {
          citycode: "0379",
          adcode: "410324",
          name: "栾川县",
          center: {
            lng: 111.615729,
            lat: 33.7857
          }
        },
        {
          citycode: "0379",
          adcode: "410329",
          name: "伊川县",
          center: {
            lng: 112.425751,
            lat: 34.421741
          }
        },
        {
          citycode: "0379",
          adcode: "410307",
          name: "偃师区",
          center: {
            lng: 112.789375,
            lat: 34.72715
          }
        },
        {
          citycode: "0379",
          adcode: "410308",
          name: "孟津区",
          center: {
            lng: 112.44525,
            lat: 34.825587
          }
        },
        {
          citycode: "0379",
          adcode: "410305",
          name: "涧西区",
          center: {
            lng: 112.395766,
            lat: 34.658177
          }
        },
        {
          citycode: "0379",
          adcode: "410304",
          name: "瀍河回族区",
          center: {
            lng: 112.500131,
            lat: 34.679773
          }
        },
        {
          citycode: "0379",
          adcode: "410311",
          name: "洛龙区",
          center: {
            lng: 112.463833,
            lat: 34.619711
          }
        },
        {
          citycode: "0379",
          adcode: "410325",
          name: "嵩县",
          center: {
            lng: 112.085432,
            lat: 34.134639
          }
        },
        {
          citycode: "0379",
          adcode: "410326",
          name: "汝阳县",
          center: {
            lng: 112.473013,
            lat: 34.154283
          }
        },
        {
          citycode: "0379",
          adcode: "410302",
          name: "老城区",
          center: {
            lng: 112.469071,
            lat: 34.683645
          }
        },
        {
          citycode: "0379",
          adcode: "410303",
          name: "西工区",
          center: {
            lng: 112.428183,
            lat: 34.659959
          }
        }
      ]
    },
    {
      citycode: "0398",
      adcode: "411200",
      name: "三门峡市",
      center: {
        lng: 111.200482,
        lat: 34.773196
      },
      districtList: [
        {
          citycode: "0398",
          adcode: "411221",
          name: "渑池县",
          center: {
            lng: 111.761753,
            lat: 34.767937
          }
        },
        {
          citycode: "0398",
          adcode: "411202",
          name: "湖滨区",
          center: {
            lng: 111.188552,
            lat: 34.771296
          }
        },
        {
          citycode: "0398",
          adcode: "411281",
          name: "义马市",
          center: {
            lng: 111.874726,
            lat: 34.747563
          }
        },
        {
          citycode: "0398",
          adcode: "411203",
          name: "陕州区",
          center: {
            lng: 111.103252,
            lat: 34.72066
          }
        },
        {
          citycode: "0398",
          adcode: "411224",
          name: "卢氏县",
          center: {
            lng: 111.04522,
            lat: 34.051866
          }
        },
        {
          citycode: "0398",
          adcode: "411282",
          name: "灵宝市",
          center: {
            lng: 110.894225,
            lat: 34.517734
          }
        }
      ]
    },
    {
      citycode: "0395",
      adcode: "411100",
      name: "漯河市",
      center: {
        lng: 114.0166,
        lat: 33.58038
      },
      districtList: [
        {
          citycode: "0395",
          adcode: "411122",
          name: "临颍县",
          center: {
            lng: 113.931121,
            lat: 33.828096
          }
        },
        {
          citycode: "0395",
          adcode: "411104",
          name: "召陵区",
          center: {
            lng: 114.093879,
            lat: 33.586509
          }
        },
        {
          citycode: "0395",
          adcode: "411102",
          name: "源汇区",
          center: {
            lng: 113.984164,
            lat: 33.572319
          }
        },
        {
          citycode: "0395",
          adcode: "411103",
          name: "郾城区",
          center: {
            lng: 114.006596,
            lat: 33.587697
          }
        },
        {
          citycode: "0395",
          adcode: "411121",
          name: "舞阳县",
          center: {
            lng: 113.609327,
            lat: 33.438259
          }
        }
      ]
    },
    {
      citycode: "0374",
      adcode: "411000",
      name: "许昌市",
      center: {
        lng: 113.852004,
        lat: 34.03732
      },
      districtList: [
        {
          citycode: "0374",
          adcode: "411003",
          name: "建安区",
          center: {
            lng: 113.822869,
            lat: 34.124729
          }
        },
        {
          citycode: "0374",
          adcode: "411025",
          name: "襄城县",
          center: {
            lng: 113.506904,
            lat: 33.851609
          }
        },
        {
          citycode: "0374",
          adcode: "411002",
          name: "魏都区",
          center: {
            lng: 113.830826,
            lat: 34.047189
          }
        },
        {
          citycode: "0374",
          adcode: "411024",
          name: "鄢陵县",
          center: {
            lng: 114.177329,
            lat: 34.102985
          }
        },
        {
          citycode: "0374",
          adcode: "411081",
          name: "禹州市",
          center: {
            lng: 113.488715,
            lat: 34.142442
          }
        },
        {
          citycode: "0374",
          adcode: "411082",
          name: "长葛市",
          center: {
            lng: 113.813972,
            lat: 34.195458
          }
        }
      ]
    },
    {
      citycode: "0377",
      adcode: "411300",
      name: "南阳市",
      center: {
        lng: 112.584753,
        lat: 33.016102
      },
      districtList: [
        {
          citycode: "0377",
          adcode: "411328",
          name: "唐河县",
          center: {
            lng: 112.80829,
            lat: 32.682464
          }
        },
        {
          citycode: "0377",
          adcode: "411321",
          name: "南召县",
          center: {
            lng: 112.429277,
            lat: 33.489804
          }
        },
        {
          citycode: "0377",
          adcode: "411323",
          name: "西峡县",
          center: {
            lng: 111.473644,
            lat: 33.307272
          }
        },
        {
          citycode: "0377",
          adcode: "411303",
          name: "卧龙区",
          center: {
            lng: 112.528524,
            lat: 32.990313
          }
        },
        {
          citycode: "0377",
          adcode: "411324",
          name: "镇平县",
          center: {
            lng: 112.234571,
            lat: 33.033826
          }
        },
        {
          citycode: "0377",
          adcode: "411326",
          name: "淅川县",
          center: {
            lng: 111.490902,
            lat: 33.137831
          }
        },
        {
          citycode: "0377",
          adcode: "411325",
          name: "内乡县",
          center: {
            lng: 111.849354,
            lat: 33.044698
          }
        },
        {
          citycode: "0377",
          adcode: "411329",
          name: "新野县",
          center: {
            lng: 112.3601,
            lat: 32.521282
          }
        },
        {
          citycode: "0377",
          adcode: "411327",
          name: "社旗县",
          center: {
            lng: 112.948183,
            lat: 33.056229
          }
        },
        {
          citycode: "0377",
          adcode: "411322",
          name: "方城县",
          center: {
            lng: 113.012849,
            lat: 33.255387
          }
        },
        {
          citycode: "0377",
          adcode: "411381",
          name: "邓州市",
          center: {
            lng: 112.08745,
            lat: 32.687732
          }
        },
        {
          citycode: "0377",
          adcode: "411302",
          name: "宛城区",
          center: {
            lng: 112.539506,
            lat: 33.003564
          }
        },
        {
          citycode: "0377",
          adcode: "411330",
          name: "桐柏县",
          center: {
            lng: 113.428702,
            lat: 32.379164
          }
        }
      ]
    },
    {
      citycode: "0376",
      adcode: "411500",
      name: "信阳市",
      center: {
        lng: 114.091058,
        lat: 32.148624
      },
      districtList: [
        {
          citycode: "0376",
          adcode: "411502",
          name: "浉河区",
          center: {
            lng: 114.05867,
            lat: 32.116885
          }
        },
        {
          citycode: "0376",
          adcode: "411525",
          name: "固始县",
          center: {
            lng: 115.654066,
            lat: 32.169239
          }
        },
        {
          citycode: "0376",
          adcode: "411527",
          name: "淮滨县",
          center: {
            lng: 115.420101,
            lat: 32.474772
          }
        },
        {
          citycode: "0376",
          adcode: "411522",
          name: "光山县",
          center: {
            lng: 114.91934,
            lat: 32.010736
          }
        },
        {
          citycode: "0376",
          adcode: "411528",
          name: "息县",
          center: {
            lng: 114.740392,
            lat: 32.34312
          }
        },
        {
          citycode: "0376",
          adcode: "411521",
          name: "罗山县",
          center: {
            lng: 114.512838,
            lat: 32.20436
          }
        },
        {
          citycode: "0376",
          adcode: "411503",
          name: "平桥区",
          center: {
            lng: 114.125595,
            lat: 32.101005
          }
        },
        {
          citycode: "0376",
          adcode: "411524",
          name: "商城县",
          center: {
            lng: 115.406894,
            lat: 31.79832
          }
        },
        {
          citycode: "0376",
          adcode: "411526",
          name: "潢川县",
          center: {
            lng: 115.051683,
            lat: 32.131426
          }
        },
        {
          citycode: "0376",
          adcode: "411523",
          name: "新县",
          center: {
            lng: 114.879309,
            lat: 31.643914
          }
        }
      ]
    },
    {
      citycode: "0392",
      adcode: "410600",
      name: "鹤壁市",
      center: {
        lng: 114.297305,
        lat: 35.748329
      },
      districtList: [
        {
          citycode: "0392",
          adcode: "410622",
          name: "淇县",
          center: {
            lng: 114.208851,
            lat: 35.622571
          }
        },
        {
          citycode: "0392",
          adcode: "410602",
          name: "鹤山区",
          center: {
            lng: 114.163133,
            lat: 35.954647
          }
        },
        {
          citycode: "0392",
          adcode: "410603",
          name: "山城区",
          center: {
            lng: 114.184391,
            lat: 35.897862
          }
        },
        {
          citycode: "0392",
          adcode: "410611",
          name: "淇滨区",
          center: {
            lng: 114.298748,
            lat: 35.741763
          }
        },
        {
          citycode: "0392",
          adcode: "410621",
          name: "浚县",
          center: {
            lng: 114.550611,
            lat: 35.677249
          }
        }
      ]
    },
    {
      citycode: "0393",
      adcode: "410900",
      name: "濮阳市",
      center: {
        lng: 115.029246,
        lat: 35.762731
      },
      districtList: [
        {
          citycode: "0393",
          adcode: "410927",
          name: "台前县",
          center: {
            lng: 115.871671,
            lat: 35.970286
          }
        },
        {
          citycode: "0393",
          adcode: "410922",
          name: "清丰县",
          center: {
            lng: 115.104602,
            lat: 35.886694
          }
        },
        {
          citycode: "0393",
          adcode: "410926",
          name: "范县",
          center: {
            lng: 115.504081,
            lat: 35.85302
          }
        },
        {
          citycode: "0393",
          adcode: "410923",
          name: "南乐县",
          center: {
            lng: 115.205876,
            lat: 36.070219
          }
        },
        {
          citycode: "0393",
          adcode: "410902",
          name: "华龙区",
          center: {
            lng: 115.074453,
            lat: 35.778289
          }
        },
        {
          citycode: "0393",
          adcode: "410928",
          name: "濮阳县",
          center: {
            lng: 115.029165,
            lat: 35.713113
          }
        }
      ]
    },
    {
      citycode: "1391",
      adcode: "419001",
      name: "济源市",
      center: {
        lng: 112.602347,
        lat: 35.069057
      },
      districtList: [
        {
          citycode: "1391",
          adcode: "419001",
          name: "坡头镇",
          center: {
            lng: 112.580245,
            lat: 35.063381
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "梨林镇",
          center: {
            lng: 112.75322,
            lat: 35.088183
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "思礼镇",
          center: {
            lng: 112.388078,
            lat: 35.210276
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "五龙口镇",
          center: {
            lng: 112.761264,
            lat: 35.195598
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "王屋镇",
          center: {
            lng: 112.168531,
            lat: 35.124376
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "玉泉街道",
          center: {
            lng: 112.623553,
            lat: 35.118882
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "轵城镇",
          center: {
            lng: 112.622105,
            lat: 35.06253
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "济水街道",
          center: {
            lng: 112.595477,
            lat: 35.094386
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "沁园街道",
          center: {
            lng: 112.59321,
            lat: 35.082244
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "下冶镇",
          center: {
            lng: 112.212297,
            lat: 35.113088
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "克井镇",
          center: {
            lng: 112.63491,
            lat: 35.255031
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "天坛街道",
          center: {
            lng: 112.566796,
            lat: 35.122905
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "邵原镇",
          center: {
            lng: 112.114016,
            lat: 35.27048
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "北海街道",
          center: {
            lng: 112.568975,
            lat: 35.111552
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "承留镇",
          center: {
            lng: 112.508612,
            lat: 35.024328
          }
        },
        {
          citycode: "1391",
          adcode: "419001",
          name: "大峪镇",
          center: {
            lng: 112.31891,
            lat: 35.079253
          }
        }
      ]
    },
    {
      citycode: "0375",
      adcode: "410400",
      name: "平顶山市",
      center: {
        lng: 113.192595,
        lat: 33.766554
      },
      districtList: [
        {
          citycode: "0375",
          adcode: "410403",
          name: "卫东区",
          center: {
            lng: 113.335316,
            lat: 33.735388
          }
        },
        {
          citycode: "0375",
          adcode: "410423",
          name: "鲁山县",
          center: {
            lng: 112.908052,
            lat: 33.738434
          }
        },
        {
          citycode: "0375",
          adcode: "410411",
          name: "湛河区",
          center: {
            lng: 113.320873,
            lat: 33.725681
          }
        },
        {
          citycode: "0375",
          adcode: "410481",
          name: "舞钢市",
          center: {
            lng: 113.516427,
            lat: 33.314147
          }
        },
        {
          citycode: "0375",
          adcode: "410402",
          name: "新华区",
          center: {
            lng: 113.293977,
            lat: 33.737251
          }
        },
        {
          citycode: "0375",
          adcode: "410422",
          name: "叶县",
          center: {
            lng: 113.357476,
            lat: 33.627437
          }
        },
        {
          citycode: "0375",
          adcode: "410404",
          name: "石龙区",
          center: {
            lng: 112.898845,
            lat: 33.899247
          }
        },
        {
          citycode: "0375",
          adcode: "410482",
          name: "汝州市",
          center: {
            lng: 112.844696,
            lat: 34.16717
          }
        },
        {
          citycode: "0375",
          adcode: "410421",
          name: "宝丰县",
          center: {
            lng: 113.054538,
            lat: 33.869159
          }
        },
        {
          citycode: "0375",
          adcode: "410425",
          name: "郏县",
          center: {
            lng: 113.21261,
            lat: 33.971787
          }
        }
      ]
    },
    {
      citycode: "0378",
      adcode: "410200",
      name: "开封市",
      center: {
        lng: 114.314278,
        lat: 34.798083
      },
      districtList: [
        {
          citycode: "0378",
          adcode: "410221",
          name: "杞县",
          center: {
            lng: 114.782629,
            lat: 34.549731
          }
        },
        {
          citycode: "0378",
          adcode: "410205",
          name: "禹王台区",
          center: {
            lng: 114.348105,
            lat: 34.777052
          }
        },
        {
          citycode: "0378",
          adcode: "410222",
          name: "通许县",
          center: {
            lng: 114.47315,
            lat: 34.502053
          }
        },
        {
          citycode: "0378",
          adcode: "410223",
          name: "尉氏县",
          center: {
            lng: 114.19305,
            lat: 34.411437
          }
        },
        {
          citycode: "0378",
          adcode: "410225",
          name: "兰考县",
          center: {
            lng: 114.818228,
            lat: 34.856372
          }
        },
        {
          citycode: "0378",
          adcode: "410212",
          name: "祥符区",
          center: {
            lng: 114.441406,
            lat: 34.757546
          }
        },
        {
          citycode: "0378",
          adcode: "410203",
          name: "顺河回族区",
          center: {
            lng: 114.360824,
            lat: 34.795933
          }
        },
        {
          citycode: "0378",
          adcode: "410202",
          name: "龙亭区",
          center: {
            lng: 114.355378,
            lat: 34.815515
          }
        },
        {
          citycode: "0378",
          adcode: "410204",
          name: "鼓楼区",
          center: {
            lng: 114.348356,
            lat: 34.788473
          }
        }
      ]
    },
    {
      citycode: "0371",
      adcode: "410100",
      name: "郑州市",
      center: {
        lng: 113.625351,
        lat: 34.746303
      },
      districtList: [
        {
          citycode: "0371",
          adcode: "410185",
          name: "登封市",
          center: {
            lng: 113.05056,
            lat: 34.454877
          }
        },
        {
          citycode: "0371",
          adcode: "410102",
          name: "中原区",
          center: {
            lng: 113.612966,
            lat: 34.74828
          }
        },
        {
          citycode: "0371",
          adcode: "410108",
          name: "惠济区",
          center: {
            lng: 113.617055,
            lat: 34.867994
          }
        },
        {
          citycode: "0371",
          adcode: "410105",
          name: "金水区",
          center: {
            lng: 113.6603,
            lat: 34.800415
          }
        },
        {
          citycode: "0371",
          adcode: "410106",
          name: "上街区",
          center: {
            lng: 113.309185,
            lat: 34.803514
          }
        },
        {
          citycode: "0371",
          adcode: "410122",
          name: "中牟县",
          center: {
            lng: 113.975798,
            lat: 34.720535
          }
        },
        {
          citycode: "0371",
          adcode: "410103",
          name: "二七区",
          center: {
            lng: 113.640177,
            lat: 34.724138
          }
        },
        {
          citycode: "0371",
          adcode: "410181",
          name: "巩义市",
          center: {
            lng: 113.022354,
            lat: 34.748207
          }
        },
        {
          citycode: "0371",
          adcode: "410183",
          name: "新密市",
          center: {
            lng: 113.390932,
            lat: 34.540216
          }
        },
        {
          citycode: "0371",
          adcode: "410184",
          name: "新郑市",
          center: {
            lng: 113.74024,
            lat: 34.396479
          }
        },
        {
          citycode: "0371",
          adcode: "410182",
          name: "荥阳市",
          center: {
            lng: 113.383385,
            lat: 34.7866
          }
        },
        {
          citycode: "0371",
          adcode: "410104",
          name: "管城回族区",
          center: {
            lng: 113.677446,
            lat: 34.754436
          }
        }
      ]
    },
    {
      citycode: "0373",
      adcode: "410700",
      name: "新乡市",
      center: {
        lng: 113.92679,
        lat: 35.303589
      },
      districtList: [
        {
          citycode: "0373",
          adcode: "410724",
          name: "获嘉县",
          center: {
            lng: 113.657551,
            lat: 35.260153
          }
        },
        {
          citycode: "0373",
          adcode: "410711",
          name: "牧野区",
          center: {
            lng: 113.908561,
            lat: 35.315614
          }
        },
        {
          citycode: "0373",
          adcode: "410703",
          name: "卫滨区",
          center: {
            lng: 113.865666,
            lat: 35.301796
          }
        },
        {
          citycode: "0373",
          adcode: "410783",
          name: "长垣市",
          center: {
            lng: 114.66885,
            lat: 35.201628
          }
        },
        {
          citycode: "0373",
          adcode: "410721",
          name: "新乡县",
          center: {
            lng: 113.813884,
            lat: 35.170066
          }
        },
        {
          citycode: "0373",
          adcode: "410726",
          name: "延津县",
          center: {
            lng: 114.205624,
            lat: 35.165876
          }
        },
        {
          citycode: "0373",
          adcode: "410702",
          name: "红旗区",
          center: {
            lng: 113.875211,
            lat: 35.302952
          }
        },
        {
          citycode: "0373",
          adcode: "410782",
          name: "辉县市",
          center: {
            lng: 113.80572,
            lat: 35.462964
          }
        },
        {
          citycode: "0373",
          adcode: "410781",
          name: "卫辉市",
          center: {
            lng: 114.064584,
            lat: 35.398357
          }
        },
        {
          citycode: "0373",
          adcode: "410704",
          name: "凤泉区",
          center: {
            lng: 113.916183,
            lat: 35.384428
          }
        },
        {
          citycode: "0373",
          adcode: "410725",
          name: "原阳县",
          center: {
            lng: 113.939829,
            lat: 35.066873
          }
        },
        {
          citycode: "0373",
          adcode: "410727",
          name: "封丘县",
          center: {
            lng: 114.418907,
            lat: 35.041237
          }
        }
      ]
    },
    {
      citycode: "0391",
      adcode: "410800",
      name: "焦作市",
      center: {
        lng: 113.241902,
        lat: 35.215726
      },
      districtList: [
        {
          citycode: "0391",
          adcode: "410803",
          name: "中站区",
          center: {
            lng: 113.182847,
            lat: 35.237227
          }
        },
        {
          citycode: "0391",
          adcode: "410802",
          name: "解放区",
          center: {
            lng: 113.230555,
            lat: 35.240403
          }
        },
        {
          citycode: "0391",
          adcode: "410804",
          name: "马村区",
          center: {
            lng: 113.32212,
            lat: 35.257084
          }
        },
        {
          citycode: "0391",
          adcode: "410821",
          name: "修武县",
          center: {
            lng: 113.447862,
            lat: 35.22286
          }
        },
        {
          citycode: "0391",
          adcode: "410811",
          name: "山阳区",
          center: {
            lng: 113.254581,
            lat: 35.215054
          }
        },
        {
          citycode: "0391",
          adcode: "410883",
          name: "孟州市",
          center: {
            lng: 112.791372,
            lat: 34.907229
          }
        },
        {
          citycode: "0391",
          adcode: "410825",
          name: "温县",
          center: {
            lng: 113.08067,
            lat: 34.93961
          }
        },
        {
          citycode: "0391",
          adcode: "410823",
          name: "武陟县",
          center: {
            lng: 113.401848,
            lat: 35.099458
          }
        },
        {
          citycode: "0391",
          adcode: "410882",
          name: "沁阳市",
          center: {
            lng: 112.950873,
            lat: 35.087569
          }
        },
        {
          citycode: "0391",
          adcode: "410822",
          name: "博爱县",
          center: {
            lng: 113.064701,
            lat: 35.170332
          }
        }
      ]
    },
    {
      citycode: "0370",
      adcode: "411400",
      name: "商丘市",
      center: {
        lng: 115.656358,
        lat: 34.415165
      },
      districtList: [
        {
          citycode: "0370",
          adcode: "411421",
          name: "民权县",
          center: {
            lng: 115.175019,
            lat: 34.648384
          }
        },
        {
          citycode: "0370",
          adcode: "411422",
          name: "睢县",
          center: {
            lng: 115.071957,
            lat: 34.446572
          }
        },
        {
          citycode: "0370",
          adcode: "411424",
          name: "柘城县",
          center: {
            lng: 115.305182,
            lat: 34.092015
          }
        },
        {
          citycode: "0370",
          adcode: "411423",
          name: "宁陵县",
          center: {
            lng: 115.314221,
            lat: 34.461226
          }
        },
        {
          citycode: "0370",
          adcode: "411403",
          name: "睢阳区",
          center: {
            lng: 115.653258,
            lat: 34.389048
          }
        },
        {
          citycode: "0370",
          adcode: "411402",
          name: "梁园区",
          center: {
            lng: 115.613609,
            lat: 34.444519
          }
        },
        {
          citycode: "0370",
          adcode: "411425",
          name: "虞城县",
          center: {
            lng: 115.828519,
            lat: 34.400868
          }
        },
        {
          citycode: "0370",
          adcode: "411481",
          name: "永城市",
          center: {
            lng: 116.449864,
            lat: 33.929927
          }
        },
        {
          citycode: "0370",
          adcode: "411426",
          name: "夏邑县",
          center: {
            lng: 116.131422,
            lat: 34.237801
          }
        }
      ]
    },
    {
      citycode: "0394",
      adcode: "411600",
      name: "周口市",
      center: {
        lng: 114.701222,
        lat: 33.634652
      },
      districtList: [
        {
          citycode: "0394",
          adcode: "411623",
          name: "商水县",
          center: {
            lng: 114.608135,
            lat: 33.562072
          }
        },
        {
          citycode: "0394",
          adcode: "411602",
          name: "川汇区",
          center: {
            lng: 114.650551,
            lat: 33.647679
          }
        },
        {
          citycode: "0394",
          adcode: "411628",
          name: "鹿邑县",
          center: {
            lng: 115.484525,
            lat: 33.860698
          }
        },
        {
          citycode: "0394",
          adcode: "411603",
          name: "淮阳区",
          center: {
            lng: 114.852604,
            lat: 33.731543
          }
        },
        {
          citycode: "0394",
          adcode: "411622",
          name: "西华县",
          center: {
            lng: 114.529709,
            lat: 33.768277
          }
        },
        {
          citycode: "0394",
          adcode: "411627",
          name: "太康县",
          center: {
            lng: 114.837946,
            lat: 34.064513
          }
        },
        {
          citycode: "0394",
          adcode: "411624",
          name: "沈丘县",
          center: {
            lng: 115.098541,
            lat: 33.409805
          }
        },
        {
          citycode: "0394",
          adcode: "411681",
          name: "项城市",
          center: {
            lng: 114.875128,
            lat: 33.465609
          }
        },
        {
          citycode: "0394",
          adcode: "411621",
          name: "扶沟县",
          center: {
            lng: 114.394666,
            lat: 34.060062
          }
        },
        {
          citycode: "0394",
          adcode: "411625",
          name: "郸城县",
          center: {
            lng: 115.177141,
            lat: 33.64601
          }
        }
      ]
    },
    {
      citycode: "0396",
      adcode: "411700",
      name: "驻马店市",
      center: {
        lng: 114.021988,
        lat: 33.014038
      },
      districtList: [
        {
          citycode: "0396",
          adcode: "411728",
          name: "遂平县",
          center: {
            lng: 114.013323,
            lat: 33.146316
          }
        },
        {
          citycode: "0396",
          adcode: "411727",
          name: "汝南县",
          center: {
            lng: 114.362477,
            lat: 33.006808
          }
        },
        {
          citycode: "0396",
          adcode: "411723",
          name: "平舆县",
          center: {
            lng: 114.618537,
            lat: 32.96344
          }
        },
        {
          citycode: "0396",
          adcode: "411721",
          name: "西平县",
          center: {
            lng: 114.021492,
            lat: 33.387658
          }
        },
        {
          citycode: "0396",
          adcode: "411722",
          name: "上蔡县",
          center: {
            lng: 114.264381,
            lat: 33.262439
          }
        },
        {
          citycode: "0396",
          adcode: "411729",
          name: "新蔡县",
          center: {
            lng: 114.965519,
            lat: 32.74488
          }
        },
        {
          citycode: "0396",
          adcode: "411724",
          name: "正阳县",
          center: {
            lng: 114.392774,
            lat: 32.605697
          }
        },
        {
          citycode: "0396",
          adcode: "411725",
          name: "确山县",
          center: {
            lng: 114.016818,
            lat: 32.82134
          }
        },
        {
          citycode: "0396",
          adcode: "411702",
          name: "驿城区",
          center: {
            lng: 113.993753,
            lat: 32.97455
          }
        },
        {
          citycode: "0396",
          adcode: "411726",
          name: "泌阳县",
          center: {
            lng: 113.327144,
            lat: 32.723974
          }
        }
      ]
    },
    {
      citycode: "0372",
      adcode: "410500",
      name: "安阳市",
      center: {
        lng: 114.39248,
        lat: 36.098779
      },
      districtList: [
        {
          citycode: "0372",
          adcode: "410503",
          name: "北关区",
          center: {
            lng: 114.355742,
            lat: 36.10766
          }
        },
        {
          citycode: "0372",
          adcode: "410523",
          name: "汤阴县",
          center: {
            lng: 114.357686,
            lat: 35.925155
          }
        },
        {
          citycode: "0372",
          adcode: "410522",
          name: "安阳县",
          center: {
            lng: 114.462953,
            lat: 36.09211
          }
        },
        {
          citycode: "0372",
          adcode: "410502",
          name: "文峰区",
          center: {
            lng: 114.356967,
            lat: 36.090593
          }
        },
        {
          citycode: "0372",
          adcode: "410505",
          name: "殷都区",
          center: {
            lng: 114.303454,
            lat: 36.109938
          }
        },
        {
          citycode: "0372",
          adcode: "410506",
          name: "龙安区",
          center: {
            lng: 114.301037,
            lat: 36.076937
          }
        },
        {
          citycode: "0372",
          adcode: "410527",
          name: "内黄县",
          center: {
            lng: 114.90146,
            lat: 35.972016
          }
        },
        {
          citycode: "0372",
          adcode: "410581",
          name: "林州市",
          center: {
            lng: 113.819275,
            lat: 36.084127
          }
        },
        {
          citycode: "0372",
          adcode: "410526",
          name: "滑县",
          center: {
            lng: 114.517977,
            lat: 35.576128
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/henan.js